import { render } from "./Pointer.vue?vue&type=template&id=08abd76e"
import script from "./Pointer.vue?vue&type=script&lang=js"
export * from "./Pointer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__